// src/services/ApiRoutes.ts

/**
 * Enum for managing API routes.
 * This helps avoid hardcoding the routes in multiple places.
 */
export enum ApiRoutes {
  LOGIN = "/api/v1/cc-user/login",
  LOGOUT = "/api/v1/cc-user/logout",
  CHANGE_PASSWORD = "/api/v1/cc-user/update-password",
  PASSWORD_RESET = "/api/v1/cc-user/request-temporary-password",
  CREATE_TERMINAL = "/api/v1/cc-franchise/create-terminal",
  TERMINAL_DETAILS = "/api/v1/cc-franchise/terminal",
  TERMINAL_UPDATE = "/api/v1/cc-franchise/update-terminal",
  DELETE_TERMINAL = "/api/v1/cc-franchise/delete-terminal",
  CREATE_FRANCHISE = "/api/v1/cc-franchise/create-franchise",
  DELETE_FRANCHISE = "api/v1/cc-franchise/franchise",
  GET_FRANCHISES = "/api/v1/cc-franchise",
  UPDATE_FRANCHISE = "/api/v1/cc-franchise/update-franchise",
  CREATE_SUPPORT_USERS = "/api/v1/cc-user/create-user",
  GET_SUPPORT_USERS = "/api/v1/cc-user/users",
  UPDATE_SUPPORT_USERS = "/api/v1/cc-user/update-user",
  DELETE_SUPPORT_USERS = "/api/v1/cc-user/delete-user",
  GET_ORDERS = "/api/v1/orders",
  CREATE_FRANCHISE_USER = "/api/v1/franchise-user/create-user",
  GET_FRANCHISE_USER = "/api/v1/franchise-user/users",
  DELETE_FRANCHISE_USER = "/api/v1/franchise-user/delete-user",
  UPDATE_FRANCHISE_USER = "/api/v1/franchise-user/update-user",
  REFUND_AMOUNT = "/api/v1/cc-payment/refund",
  REFUND_AMOUNT_STATUS = "/api/v1/cc-payment/refund-status"
}